'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingConstants = require('conversations-core/hublytics/TrackingConstants');

var _WizardStepTypes = require('conversations-core/constants/WizardStepTypes');

var _WizardStepTypes2 = _interopRequireDefault(_WizardStepTypes);

var _ = require('_');

var _RepStatus = require('conversations-core/constants/RepStatus');

var _TargetAudienceTypes = require('conversations-schema/constants/TargetAudienceTypes');

var _TargetAudienceTypes2 = _interopRequireDefault(_TargetAudienceTypes);

var _NotificationTypes = require('conversations-schema/constants/NotificationTypes');

var _NotificationTypes2 = _interopRequireDefault(_NotificationTypes);

var _LauncherTypes = require('conversations-schema/constants/LauncherTypes');

var _LauncherTypes2 = _interopRequireDefault(_LauncherTypes);

var _OnboardingLeaveReasons = require('conversations-core/constants/OnboardingLeaveReasons');

var _OnboardingLeaveReasons2 = _interopRequireDefault(_OnboardingLeaveReasons);

var _eventPropTypes = require('event-tracking-tools/events/eventPropTypes');

var _eventPropTypes2 = _interopRequireDefault(_eventPropTypes);

var _hublyticsEventClasses = require('event-tracking-tools/hublytics/hublyticsEventClasses');

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_MESSAGE = _TrackingConstants.EVENTS.UPDATE_MESSAGE,
    UPDATE_SETTINGS = _TrackingConstants.EVENTS.UPDATE_SETTINGS,
    VIEW_WIZARD_STEP = _TrackingConstants.EVENTS.VIEW_WIZARD_STEP,
    ONBOARDING_INTERACTION = _TrackingConstants.EVENTS.ONBOARDING_INTERACTION,
    CHANGE_WINDOW_LOCATION = _TrackingConstants.EVENTS.CHANGE_WINDOW_LOCATION,
    ABANDON_ONBOARDING = _TrackingConstants.EVENTS.ABANDON_ONBOARDING,
    WIDGET_INTERACTION = _TrackingConstants.EVENTS.WIDGET_INTERACTION,
    PAGE_VIEW = _TrackingConstants.EVENTS.PAGE_VIEW,
    CHAT_INTERACTION = _TrackingConstants.EVENTS.CHAT_INTERACTION,
    INDEX_INTERACTION = _TrackingConstants.EVENTS.INDEX_INTERACTION,
    TOGGLE_REP_STATUS = _TrackingConstants.EVENTS.TOGGLE_REP_STATUS,
    SETTINGS_INTERACTION = _TrackingConstants.EVENTS.SETTINGS_INTERACTION;
var CREATE_MESSAGE = _TrackingConstants.EVENT_ACTION_NAMES.CREATE_MESSAGE,
    UPDATE_EXISTING_MESSAGE = _TrackingConstants.EVENT_ACTION_NAMES.UPDATE_EXISTING_MESSAGE,
    SET_MESSAGE_PROPERTY = _TrackingConstants.EVENT_ACTION_NAMES.SET_MESSAGE_PROPERTY,
    SET_MESSAGE_TARGET_AUDIENCE = _TrackingConstants.EVENT_ACTION_NAMES.SET_MESSAGE_TARGET_AUDIENCE,
    TOGGLE_MESSAGE_STATUS = _TrackingConstants.EVENT_ACTION_NAMES.TOGGLE_MESSAGE_STATUS,
    SEND_EMBED_CODE = _TrackingConstants.EVENT_ACTION_NAMES.SEND_EMBED_CODE,
    SET_NOTIFICATION = _TrackingConstants.EVENT_ACTION_NAMES.SET_NOTIFICATION,
    SET_LAUNCHERTYPE = _TrackingConstants.EVENT_ACTION_NAMES.SET_LAUNCHERTYPE,
    SELECT_EMBED_CODE_OPTION = _TrackingConstants.EVENT_ACTION_NAMES.SELECT_EMBED_CODE_OPTION,
    CREATE_CONTACT_FOR_CHANNEL = _TrackingConstants.EVENT_ACTION_NAMES.CREATE_CONTACT_FOR_CHANNEL,
    SET_PORTAL_SETTINGS = _TrackingConstants.EVENT_ACTION_NAMES.SET_PORTAL_SETTINGS,
    SET_USER_SETTING = _TrackingConstants.EVENT_ACTION_NAMES.SET_USER_SETTING,
    CLICK_MEETINGS_LINK = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_MEETINGS_LINK,
    CLICK_USER_DESCRIPTION = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_USER_DESCRIPTION,
    SEND_VISITOR_EMAIL_ADDRESS = _TrackingConstants.EVENT_ACTION_NAMES.SEND_VISITOR_EMAIL_ADDRESS,
    CLOSE_CONVERSATION = _TrackingConstants.EVENT_ACTION_NAMES.CLOSE_CONVERSATION,
    SET_REP_STATUS = _TrackingConstants.EVENT_ACTION_NAMES.SET_REP_STATUS,
    NAVIGATE = _TrackingConstants.EVENT_ACTION_NAMES.NAVIGATE,
    CLICK_CONTACT = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_CONTACT,
    INITIALIZE_CONVERSATION = _TrackingConstants.EVENT_ACTION_NAMES.INITIALIZE_CONVERSATION,
    TOGGLE_WIDGET = _TrackingConstants.EVENT_ACTION_NAMES.TOGGLE_WIDGET,
    SEND_MESSAGE = _TrackingConstants.EVENT_ACTION_NAMES.SEND_MESSAGE,
    DISMISS_PROFILE_TIP = _TrackingConstants.EVENT_ACTION_NAMES.DISMISS_PROFILE_TIP,
    CLICK_PROFILE_TIP = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_PROFILE_TIP,
    WIDGET_LOADED = _TrackingConstants.EVENT_ACTION_NAMES.WIDGET_LOADED,
    LEFT_ONBOARDING = _TrackingConstants.EVENT_ACTION_NAMES.LEFT_ONBOARDING,
    SELECT_PERMISSION_VALUE = _TrackingConstants.EVENT_ACTION_NAMES.SELECT_PERMISSION_VALUE,
    CLICK_BANNER_ACTION = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_BANNER_ACTION,
    CLICK_NOTIFICATION_PERMISSION_HELP_LINK = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_NOTIFICATION_PERMISSION_HELP_LINK,
    CLICK_VIRAL_LINK = _TrackingConstants.EVENT_ACTION_NAMES.CLICK_VIRAL_LINK;


var RequiredPropKeyTypes = { user_id: _eventPropTypes2.default.NUMBER };
var RequiredWidgetPropKeyTypes = { page_url: _eventPropTypes2.default.STRING };

var eventSchema = (0, _immutable.Map)({
  clickPermissionHelpLink: {
    name: SETTINGS_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_NOTIFICATION_PERMISSION_HELP_LINK,
      parentName: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },

  selectPermissionValue: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SELECT_PERMISSION_VALUE,
      permissionType: _eventPropTypes2.default.ONE_OF(['default', 'denied', 'granted'])
    }, RequiredPropKeyTypes)
  },

  clickBannerAction: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_BANNER_ACTION,
      permissionType: _eventPropTypes2.default.ONE_OF(['default', 'denied', 'granted'])
    }, RequiredPropKeyTypes)
  },

  leftOnboarding: {
    name: ONBOARDING_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: LEFT_ONBOARDING,
      reason: _eventPropTypes2.default.ONE_OF(Object.keys(_OnboardingLeaveReasons2.default))
    }, RequiredPropKeyTypes)
  },

  dismissProfileTip: {
    name: INDEX_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: DISMISS_PROFILE_TIP
    }, RequiredPropKeyTypes)
  },
  createContactForChannel: {
    name: CHAT_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CREATE_CONTACT_FOR_CHANNEL,
      visitorId: _eventPropTypes2.default.NUMBER,
      new_contact: _eventPropTypes2.default.BOOLEAN
    }, RequiredPropKeyTypes)
  },
  clickProfileTip: {
    name: INDEX_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_PROFILE_TIP
    }, RequiredPropKeyTypes)
  },
  selectEmbedCodeOption: {
    name: ONBOARDING_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SELECT_EMBED_CODE_OPTION,
      method: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },
  launcherSave: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_LAUNCHERTYPE,
      type: _eventPropTypes2.default.ONE_OF(Object.keys(_LauncherTypes2.default))
    }, RequiredPropKeyTypes)
  },
  createMessage: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CREATE_MESSAGE,
      message_id: _eventPropTypes2.default.NUMBER
    }, RequiredPropKeyTypes)
  },
  updateMessage: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: UPDATE_EXISTING_MESSAGE,
      message_id: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },
  setMessageProperty: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_MESSAGE_PROPERTY,
      property_name: _eventPropTypes2.default.STRING,
      property_value: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },
  setMessageTarget: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_MESSAGE_TARGET_AUDIENCE,
      target_audience_type: _eventPropTypes2.default.ONE_OF(Object.keys(_TargetAudienceTypes2.default))
    }, RequiredPropKeyTypes)
  },
  toggleMessageStatus: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: TOGGLE_MESSAGE_STATUS,
      message_id: _eventPropTypes2.default.STRING,
      new_status: _eventPropTypes2.default.BOOLEAN
    }, RequiredPropKeyTypes)
  },
  sendEmbedCode: {
    name: UPDATE_MESSAGE,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SEND_EMBED_CODE,
      message_id: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },
  setNotification: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_NOTIFICATION,
      notification_type: _eventPropTypes2.default.ONE_OF(Object.keys(_NotificationTypes2.default))
    }, RequiredPropKeyTypes)
  },
  setPortalSetting: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_PORTAL_SETTINGS,
      setting_name: _eventPropTypes2.default.STRING,
      setting_value: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },
  setUserSetting: {
    name: UPDATE_SETTINGS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SET_USER_SETTING,
      setting_name: _eventPropTypes2.default.STRING,
      setting_value: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes)
  },

  viewWizardStep: {
    name: VIEW_WIZARD_STEP,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      step_name: _eventPropTypes2.default.ONE_OF((0, _.values)(_WizardStepTypes2.default)),
      in_onboarding: _eventPropTypes2.default.BOOLEAN
    }, RequiredPropKeyTypes)
  },
  changeWindowLocation: {
    name: CHANGE_WINDOW_LOCATION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      page_url: _eventPropTypes2.default.STRING
    }
  },
  abandonOnboarding: {
    name: ABANDON_ONBOARDING,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      page_url: _eventPropTypes2.default.STRING,
      in_onboarding: _eventPropTypes2.default.BOOLEAN
    }
  },
  pageView: {
    name: PAGE_VIEW,
    type: _hublyticsEventClasses.VIEW,
    propTypes: {
      where_screen: _eventPropTypes2.default.STRING,
      where_subscreen: _eventPropTypes2.default.STRING
    }
  },
  setRepStatus: {
    name: TOGGLE_REP_STATUS,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: SET_REP_STATUS,
      new_status: _eventPropTypes2.default.ONE_OF(Object.keys(_RepStatus.repStatuses))
    }
  },
  closeConversation: {
    name: CHAT_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: CLOSE_CONVERSATION
    }
  },
  navigateFromConversation: {
    name: CHAT_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: NAVIGATE,
      page_url: _eventPropTypes2.default.STRING
    }
  },
  clickNameInChat: {
    name: CHAT_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: CLICK_CONTACT,
      contact_name: _eventPropTypes2.default.STRING
    }
  },

  // WIDGET_INTERACTION
  clickMeetingsLink: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_MEETINGS_LINK,
      link_url: _eventPropTypes2.default.STRING
    }, RequiredPropKeyTypes, RequiredWidgetPropKeyTypes)
  },
  clickUserDescription: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_USER_DESCRIPTION
    }, RequiredWidgetPropKeyTypes, RequiredPropKeyTypes)
  },
  sendVisitorEmailAddress: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: SEND_VISITOR_EMAIL_ADDRESS
    }, RequiredWidgetPropKeyTypes, RequiredPropKeyTypes)
  },
  sendInitialMessage: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: INITIALIZE_CONVERSATION,
      online: _eventPropTypes2.default.BOOLEAN
    }
  },
  sendMessage: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: {
      action: SEND_MESSAGE,
      online: _eventPropTypes2.default.BOOLEAN
    }
  },
  toggleWidget: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: TOGGLE_WIDGET,
      is_open: _eventPropTypes2.default.BOOLEAN
    }, RequiredWidgetPropKeyTypes)
  },
  widgetLoaded: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: WIDGET_LOADED,
      online: _eventPropTypes2.default.BOOLEAN
    }, RequiredWidgetPropKeyTypes)
  },
  clickViralLink: {
    name: WIDGET_INTERACTION,
    type: _hublyticsEventClasses.INTERACTION,
    propTypes: (0, _.extend)({
      action: CLICK_VIRAL_LINK,
      page_url: _eventPropTypes2.default.STRING
    }, RequiredWidgetPropKeyTypes)
  }
});

exports.default = eventSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/hublytics/MessagesEventSchema.js
// module id = 292
// module chunks = 0